import React from "react";
import { Form, Col } from "react-bootstrap";
import Select from "react-select";
import { FormHelper, TIPO_SISTEMA_EXTERNO_DLL, TIPO_SISTEMA_EXTERNO } from "utils";
import RadioGroup from "components/RadioGroup/RadioGroup";
import DropZone from "components/DropZone/Dropzone";
import EditSection from "components/PantallasEdit/EditSection/EditSection";
import SectionRow from "components/PantallasEdit/SectionRow/SectionRow";
import InputContainer from "components/PantallasEdit/InputContainer/InputContainer";
import VincularCuentaQuickbooks from "components/SistemasExternos/VincularCuentaQuickBooks";

export default function OtrasConfiguracionesTab({
  compania,
  setCompania,
  setCheckedProp,
  onFileChange,
  configuracionSistemaExterno,
  setconfiguracionSistemaExterno,
  configuration,
  usuario,
  AMBIENTE_LIST,
  showLoading,
  hideLoading,
}) {
  compania.Ambiente = compania.Ambiente ? compania.Ambiente : AMBIENTE_LIST[0].value;

  return (
    <div className="px-3 pb-4">
      <EditSection title="Información de Firma Digital" style={{}}>
        <SectionRow columns={3}>
          <InputContainer stacked label="Certificado">
            <DropZone
              label="Seleccione un archivo .p12"
              updateFilesCb={(f) => onFileChange(f, "Certificado")}
              multiple={false}
              type="p12"
            />
          </InputContainer>

          <InputContainer stacked label="Key Certificado">
            <Form.Control
              name="KeyCertificado"
              type="password"
              onChange={(e) => FormHelper.handleChange(e, setCompania)}
              value={compania.KeyCertificado}
            />
          </InputContainer>
        </SectionRow>
      </EditSection>

      {!configuration.EsProduccion && (
        <EditSection title="Ambiente de Desarrollo para Integración" style={{}}>
          <SectionRow>
            <InputContainer>
              <RadioGroup
                options={AMBIENTE_LIST}
                selectedOption={compania.Ambiente}
                onChange={(e) =>
                  setCompania({
                    ...compania,
                    Ambiente: e.target.value,
                  })
                }
              />
            </InputContainer>
          </SectionRow>
        </EditSection>
      )}

      <EditSection title="Vincular con Sistemas Externos" style={{}}>
        <SectionRow multilinea>
          <InputContainer label="Configurar Sistema Externo" labelSize={2}>
            <Form.Check
              type="switch"
              id="ckSistemaExterno"
              name="UsaSistemaExterno"
              checked={compania.UsaSistemaExterno}
              onChange={setCheckedProp}
              label=""
            />
          </InputContainer>
        </SectionRow>

        {compania.UsaSistemaExterno && (
          <>
            <SectionRow>
              <InputContainer stacked label="Tipo">
                <Select
                  className="react-select primary mb-2"
                  classNamePrefix="react-select"
                  name="TipoSistemaExterno"
                  onChange={(e) => {

                    setconfiguracionSistemaExterno({
                      ...configuracionSistemaExterno,
                      Tipo: e.value,
                    });
                  }}
                  options={TIPO_SISTEMA_EXTERNO_DLL}
                  value={TIPO_SISTEMA_EXTERNO_DLL.filter(function (option) {
                    return option.value === configuracionSistemaExterno.Tipo;
                  })}
                />
              </InputContainer>
            </SectionRow>
            {configuracionSistemaExterno.Tipo ===
              TIPO_SISTEMA_EXTERNO.QUICKBOOKS &&
              usuario.CompaniaId && (
                <VincularCuentaQuickbooks
                  showLoading={showLoading}
                  hideLoading={hideLoading}
                ></VincularCuentaQuickbooks>
              )}
          </>
        )}
      </EditSection>
    </div>
  );
}
